// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#email-builder-container iframe{width:100%;height:calc(100vh - 56px)}`, "",{"version":3,"sources":["webpack://./src/pages/Builder.vue"],"names":[],"mappings":"AAAA,gCACE,UAAA,CACA,yBAAA","sourcesContent":["#email-builder-container iframe {\n  width: 100%;\n  height: calc(100vh - 56px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
